import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="section-padding bg-background-50">
      <div className="section-container max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          关于每日黑料
        </h2>
        <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
          {aboutData.description}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-6 mt-8">
          <div className="text-center">
            <div className="text-2xl font-heading font-bold text-primary-500">500万+</div>
            <div className="text-xs text-foreground-500 mt-1">注册用户</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-heading font-bold text-accent-500">99.7%</div>
            <div className="text-xs text-foreground-500 mt-1">信息核验率</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-heading font-bold text-primary-500">24h</div>
            <div className="text-xs text-foreground-500 mt-1">申诉响应</div>
          </div>
        </div>
      </div>
    </section>
  );
}